enum Role {
  ADMIN = 'Admin',
  ADMIN_LIGHT = 'AdminLight',
  /**
   * @deprecated Please use INTERNAL_TA_FITTER
   */
  EMPLOYEE_FITTER = 'EmployeeFitter',
  EXTERNAL_TA_FITTER = 'External TA Fitter',
  EXTERNAL_NETWORK_FITTER = 'ExternalNetworkFitter',
  /**
   * @obsolete This role is no longer in use and there is no replacement. References will be removed in the near future.
   */
  INTERNAL_FITTER = 'InternalFitter',
  INTERNAL_TA_FITTER = 'Internal TA Fitter',
  /**
   * @deprecated Please use EXTERNAL_TA_FITTER
   */
  PARTNER_FITTER = 'PartnerFitter',
  /**
   * @deprecated Please use OPERATIONS
   */
  OPS = 'Ops',
  OPERATIONS = 'Operations',
  READ_ONLY = 'ReadOnly',
  SALES = 'Sales',
  SUPPORT = 'Support',
}
export { Role }
